import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AppConsts } from '@shared/AppConsts';
import { CompanyProfileCountryLookupTableDto, CountryMasterDto, CountryStateCityAppserviceServiceProxy } from '@shared/service-proxies/service-proxies';

@Component({
    standalone: false,
    selector: 'app-country-dropdown',
    templateUrl: './country-dropdown.component.html',
    styleUrls: ['./country-dropdown.component.css']
})
export class CountryDropdownComponent implements OnInit {

    @Output() EmitId = new EventEmitter<number>();
    // Input properties
    @Input() countryId: number;
    @Input() formsubmitted: boolean;
    @Input() isdisabled: boolean;
    @Input() dropDownPosition: string;
    @ViewChild('countrySelect', { read: ElementRef }) countrySelectHost: ElementRef<HTMLElement>;
    allCountry: CountryMasterDto[] = [];
    flagselected: string = '';
    countryIdrecieved: number;
    constructor(private _countryStateCityAppserviceServiceProxy: CountryStateCityAppserviceServiceProxy) { }

    ngOnInit(): void {
        if (this.dropDownPosition == '') {
            this.dropDownPosition = 'bottom';
        }

        this.getCompanyProfile();
        if (this.countryId)
            this.allCountry.forEach(x => { if (x.id === this.countryId) this.flagselected = x.tld });
    }
    ngOnChanges() {
        if (this.countryId)
            this.allCountry.forEach(x => { if (x.id === this.countryId) this.flagselected = x.tld });
        else
            this.flagselected = '';

    }

    getCompanyProfile() {
        if (!AppConsts.allCountry) {
            this._countryStateCityAppserviceServiceProxy.getAllCountry().subscribe(result => {
                AppConsts.allCountry = result; this.getCompanyProfileAfterApi(result);
            });
        } else { this.getCompanyProfileAfterApi(AppConsts.allCountry); }
    }
    getCompanyProfileAfterApi(result) {
        this.allCountry = result.filter((country) => {
            return country.name !== '';
        }).sort((a, b) => a.name.localeCompare(b.name));
        this.allCountry.forEach(x => { if (x.id === this.countryId) this.flagselected = x.tld });
    }

    SelectedCountry(event: CompanyProfileCountryLookupTableDto) {
        if (!event) {
            this.flagselected = '';
            this.EmitId.emit(undefined);
        } else {
            this.allCountry.forEach(x => { if (x.id === event.id) this.flagselected = x.tld });
            this.EmitId.emit(event.id);
        }

    }

    onCountryKeydown(event: KeyboardEvent): void {
        if (event.ctrlKey || event.metaKey || event.altKey) {
            return;
        }
        if (/^\d$/.test(event.key)) {
            event.preventDefault();
            event.stopPropagation();
        }
    }

    onCountryPaste(event: ClipboardEvent): void {
        const text = event.clipboardData?.getData('text') ?? '';
        if (!/\d/.test(text)) {
            return;
        }
        event.preventDefault();
        event.stopPropagation();
        this.writeCountrySearch(this.insertSanitizedSearch(event, text.replace(/\d/g, '')));
    }

    private syncingCountrySearch = false;

    onCountrySearch(event: { term: string } | string): void {
        const term = typeof event === 'string' ? event : (event?.term || '');
        if (!/\d/.test(term)) {
            return;
        }
        this.writeCountrySearch(term.replace(/\d/g, ''));
    }

    private insertSanitizedSearch(event: ClipboardEvent, sanitized: string): string {
        const input = event.target instanceof HTMLInputElement ? event.target : this.countrySearchInput;
        if (!input) {
            return sanitized;
        }
        const start = input.selectionStart ?? input.value.length;
        const end = input.selectionEnd ?? input.value.length;
        return `${input.value.slice(0, start)}${sanitized}${input.value.slice(end)}`.replace(/\d/g, '');
    }

    private writeCountrySearch(value: string): void {
        const input = this.countrySearchInput;
        if (!input || input.value === value || this.syncingCountrySearch) {
            return;
        }
        this.syncingCountrySearch = true;
        input.value = value;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        this.syncingCountrySearch = false;
    }

    private get countrySearchInput(): HTMLInputElement | null {
        return this.countrySelectHost?.nativeElement?.querySelector('input') ?? null;
    }
}
